import { useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { Box, Grid } from "@mui/material";
import IsLoading from "./component/common/isLoading";
import styles from "./App.module.css";
import { useDispatch, useSelector } from "react-redux";
import { IRootState, IRootThunkDispatch } from "./redux/store";
import Login from "./page/auth/Login";
import AddSnackBar from "./component/common/SnackBar";
import CMSRoute from "./component/auth/CMSRoute";
import CMSDashoard from "./page/cms/CMSDashoard";
import { restoreCmsLogin } from "./redux/auth/thunk";
import QRCodeServey from "./page/survey/QRCodeServey";
import CollectionProgress from "./page/collection/CollectionProgress";

function App() {
    const dispatch = useDispatch<IRootThunkDispatch>();
    const { isLoading } = useSelector((state: IRootState) => state.isLoading);
    const { openSnackBar, isSuccess, message } = useSelector(
        (state: IRootState) => state.initSnackBardState
    );

    const { isAuthenticated } = useSelector(
        (state: IRootState) => state.userAuth
    );
    const navigate = useNavigate();
    useEffect(() => {
        if (!isAuthenticated) {
            dispatch(restoreCmsLogin(navigate));
        }
    }, [dispatch, isAuthenticated, navigate]);

    return (
        <>
            <div>
                <Grid style={{ position: "relative" }}>
                    {isLoading ? (
                        <Box className={styles.loadingBar}>
                            <IsLoading />
                        </Box>
                    ) : (
                        <></>
                    )}

                    <Routes>
                        <Route path="/" element={<Login />}></Route>
                        <Route path="/survey" element={<QRCodeServey/>}></Route>
                        <Route path="/collection_progress" element={<CollectionProgress/>}></Route>

                        <Route
                            path="/cms"
                            element={
                                <CMSRoute>
                                    <CMSDashoard />
                                </CMSRoute>
                            }
                        ></Route>
                    </Routes>

                    {/* <Routes>
            
          </Routes> */}

                    <AddSnackBar
                        isOpen={openSnackBar}
                        isSuccess={isSuccess}
                        message={message}
                    />
                </Grid>
            </div>
        </>
    );
}

export default App;
